module.exports = __webpack_public_path__ + "static/media/play-button@2x.524143aa.png";